/**
 * A list of which sessionIDs were last selected (or are otherwise desired) per eventID.
 * Used to pre-select a session in the session calendar.
 */
const Session = require('@/lib/Sessions/Session');

class EventSessionPreferences {
    constructor() {
        this.sessions = {};
    }

    /**
     * @param {number} eventID
     *
     * @return {Session|null}
     */
    getPreferredSessionForEvent(eventID) {
        return this.sessions[eventID] || null;
    }

    /**
     * @param {number} eventID
     * @param {Session} session
     */
    setPreferredSessionForEvent(eventID, session) {
        this.sessions[eventID] = session;
    }

    getHydrationMap() {
        return {
            sessions: {
                modelCollection: Session,
            },
        };
    }
}

module.exports = EventSessionPreferences;
